(ns ncr.scratch.general)

(defn c-component []
  [:span "General scratch component"])